import React, { Fragment } from 'react';
import { CheckIcon } from 'lucide-react';
import { motion } from 'framer-motion';
interface Step {
  label: string;
  status: 'completed' | 'current' | 'upcoming';
}
interface ProgressStepperProps {
  steps: Step[];
}
export function ProgressStepper({
  steps
}: ProgressStepperProps) {
  return <div className="w-full max-w-2xl mx-auto mb-8" data-id="element-75">
      <div className="flex items-center justify-between" data-id="element-76">
        {steps.map((step, index) => <Fragment key={step.label} data-id="element-77">
            <div className="flex flex-col items-center gap-2" data-id="element-78">
              <motion.div initial={{
            scale: 0.8,
            opacity: 0
          }} animate={{
            scale: 1,
            opacity: 1
          }} transition={{
            delay: index * 0.1
          }} className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold transition-colors ${step.status === 'completed' ? 'bg-blue-600 text-white' : step.status === 'current' ? 'bg-blue-100 text-blue-600 ring-2 ring-blue-600' : 'bg-gray-100 text-gray-400'}`} data-id="element-79">
                {step.status === 'completed' ? <CheckIcon className="w-5 h-5" data-id="element-80" /> : <span data-id="element-81">{index + 1}</span>}
              </motion.div>
              <span className={`text-sm font-medium ${step.status === 'upcoming' ? 'text-gray-400' : 'text-gray-700'}`} data-id="element-82">
                {step.label}
              </span>
            </div>
            {index < steps.length - 1 && <div className="flex-1 h-0.5 bg-gray-200 mx-4 mt-[-20px]" data-id="element-83">
                <motion.div initial={{
            width: 0
          }} animate={{
            width: step.status === 'completed' ? '100%' : '0%'
          }} transition={{
            duration: 0.3,
            delay: index * 0.1
          }} className="h-full bg-blue-600" data-id="element-84" />
              </div>}
          </Fragment>)}
      </div>
    </div>;
}